export const USER = "USER";
export const HISTORY = "HISTORY";
export const CANALIZACIONHOGAR = "CANALIZACIONHOGAR";
export const HOGARREDUCER = "HOGARREDUCER";
export const LISTATENTIONS = "LISTATENTIONS";
export const ATENCIONSELECT = "ATENCIONSELECT";